var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1047 12.77C14.5422 12.77 14.8881 12.43 14.8881 12C14.8881 11.58 14.5422 11.23 14.1047 11.23L8 11.23L8 6.45C8 4 10.0247 2 12.5276 2L17.4826 2C19.9753 2 22 3.99 22 6.44L22 17.55C22 20.01 19.9651 22 17.4724 22L12.5073 22C10.0247 22 8 20.01 8 17.56L8 12.77L14.1047 12.77ZM4.3698 15.4598L1.4498 12.5498C1.2998 12.3998 1.2198 12.2098 1.2198 11.9998C1.2198 11.7998 1.2998 11.5998 1.4498 11.4598L4.3698 8.5498C4.5198 8.3998 4.7198 8.3198 4.9098 8.3198C5.1098 8.3198 5.3098 8.3998 5.4598 8.5498C5.7598 8.8498 5.7598 9.3398 5.4598 9.6398L3.8598 11.2298L7.9998 11.2298L7.9998 12.7698L3.8598 12.7698L5.4598 14.3598C5.7598 14.6598 5.7598 15.1498 5.4598 15.4498C5.1598 15.7598 4.6698 15.7598 4.3698 15.4598Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1688:9474",
    x1: 7.8001,
    y1: 21.6,
    x2: 23.4001,
    y2: 2.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.35ca96b9f97248b1fb3768705aa2bdbf.svg";
export { ForwardRef as ReactComponent };